import { IGetState, TBoardId } from '../../../../../../../../../types/types';
import {
    EPushNotificationSettingsScope,
    EPushNotificationSubscribeCases,
    EPushNotificationSettingsTypes
} from '../../../../../../../../../types/rest/IRestPushNotificationSettings';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { pushNotificationSet } from '../../../../../../../../../rest/effects/pushNotificationSettings/pushNotificationSet';
import {
    getPushNotificationMoveToListIds
} from '../../../../../../../../../store/model/selectors/getPushNotificationMoveToListIds';
import {
    getPushNotificationListChangeToIds
} from '../../../../../../../../../store/model/selectors/getPushNotificationListChangeToIds';

export const onChange = (
    boardId: TBoardId,
    scopes: EPushNotificationSettingsScope[],
    subscribeCases: EPushNotificationSubscribeCases[],
    types: EPushNotificationSettingsTypes[]
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        const moveToListIds = getPushNotificationMoveToListIds(getState(), boardId);
        const listChangedToIds = getPushNotificationListChangeToIds(getState(), boardId);
        dispatch(pushNotificationSet(boardId, scopes, subscribeCases, types, moveToListIds, listChangedToIds));
    };
    return action;
};
